module.exports = __webpack_public_path__ + "img/jr_bg.edfd2ecb.png";